(($) => {

    $.fn.stateMap = function (options) {

        // parse options
        if (!options) {
            options = {};
        }
        const select = $(options.select);

        // initialize select
        if (select.length > 0) {
            this.find('.option').each((i, el) => {
                const option = $(el);
                const id = el.id;
                const title = option.find('title').text();

                //handle dropdown selection depending on querystring
                var urlParams = new URLSearchParams(location.search);
                if (urlParams.has('state'))  // true
                {
                    var state = urlParams.get('state');
                }
                if (state != null && id == state) {
                    select.append("<option value=\"".concat(id, "\"  selected >").concat(title, "</option>"));
                    select.focus();
                }
                else {
                    select.append("<option value=\"".concat(id, "\">").concat(title, "</option>"));
                }

            });
        }

        // handle select changes
        select.on('change', event => {
            const id = scrubStateId(select.val());
            this.find('.option.active').removeClass('active');
            if (id) {
                this.find('.option#' + id).addClass('active');
            }
        });

        // handle map clicks
        this.find('.option').on('click', event => {
            this.find('.option.active').removeClass('active');
            const id = scrubStateId(event.target.id);
            const target = $(event.target);
            target.addClass('active');
            select.val(id);
            select.focus();
        });
    };

    function scrubStateId(id) {
        return String(id).replace(/\W/, '');
    }

})(jQuery);
